import { DetailMap } from '@/pages/golf/_components/detailMap'
import { DetailSearchFilter } from '@/pages/golf/detailSearch/_components/detailSearchFilter'
import { DetailSearchGraph } from '@/pages/golf/detailSearch/_components/detailSearchGraph'
import { DetailSearchResult } from '@/pages/golf/detailSearch/_components/detailSearchResult'
import { MainGolfSearchFilter } from '@/pages/main/_components/golfSearch/mainGolfSearchFilter'
import { MainGolfSearchResult } from '@/pages/main/_components/golfSearch/mainGolfSearchResult'
import { DetailSearchRegionGraph } from '@/pages/golf/detailSearch/_components/detailSearchRegionGraph'
import {
  GolfSearchState,
  initialSearchState,
  setSearchParams,
} from '@/redux/slices/golfSearchSlice'
import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { MenuHeader } from '@/pages/menu/menuHeader'
import { useLocation } from 'react-router-dom'
import { useRef, useState } from 'react'
import MenuInfo from '@/pages/menu/menuInfo'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'
import { MainGraph } from '@/pages/main/_components/graph/mainGraph'

export const DetailSearch = () => {
  const location = useLocation()
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  const listData = useSelector(
    (state: RootState) => state.golfSearch.golfListData.listData,
  )
  const { isMobile, isTablet, isDesktop } = useResponsive()

  return (
    <>
      <SEO
        title="꿀프장검색"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/golf/detailSearch"
      />
      <DetailContent>
        <DetailSearchWrapper>
          {/* <DetailSearchFilter />
      <DetailSearchResult /> */}
          <div style={{ padding: isMobile ? '0 16px' : '0' }}>
            <MenuHeader
              pathName={location.pathname}
              showWriteButton={false}
              menuInfoRef={menuInfoRef}
              loginRequired={false}
              iconActive={hasMenuInfo}
            />

            {/*<DetailSearchRegionGraph />*/}
            <MainGolfSearchFilter />
          </div>
          <div style={{ padding: isMobile ? '0 15px' : '0' }}>
            <MainGolfSearchResult />
          </div>
          <div style={{ padding: isMobile ? '0 15px' : '0' }}>
            <DetailMap data={listData} screenType="search" />
          </div>
          <DetailSearchGraph />
          <div ref={menuInfoRef}>
            <MenuInfo
              menuPath={location.pathname}
              onDataCheck={setHasMenuInfo}
            />
          </div>
        </DetailSearchWrapper>
      </DetailContent>
    </>
  )
}

const DetailSearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justifycontent: flex-end;
`

const DetailContent = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const Wrapper = styled.div`
  width: 100%;
  max-width: 480px; /* 모바일 최대 너비 제한 */
  margin: 0 auto;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
`

const Section = styled.section`
  width: 100%;
  box-sizing: border-box;
`
